import angular from 'angular';
import moment from 'moment';
import { find, map, filter, some } from 'lodash';

import ComponentModule from './component';
import DashboardComponent from './dashboard.cmpt';

export default angular
    .module('application.scene.authorized.scene.dashboard', [
        ComponentModule.name
    ])
    .component(DashboardComponent.selector, DashboardComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.dashboard', {
        url: '/dashboard/:teamId?cid&time',
        component: DashboardComponent.selector,
        params: {
            teamId: {
                value: null,
                squash: true,
                dynamic: true
            },
            cid: {
                array: true,
                value: [],
                dynamic: true
            },
            time: {
                value: null
            }
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.dashboard'
    }, (transition) => {
        let { teamId, cid, time } = transition.params() || {};

        teamId = +teamId;

        const $state = transition.injector().get('$state');
        const $q = transition.injector().get('$q');
        const sessionService = transition.injector().get('sessionService');
        const preferenceService = transition.injector().get('preferenceService');

        return $q.all([
            sessionService.initialize(),
            preferenceService.get()
        ]).then(([data, preferences]) => {
            let { teams } = data;
            let selectedTeam = find(teams, (team) => team.id === teamId);

            if (!selectedTeam) {
                return $q.reject(`No team specified.`);
            }

            transition.addResolvable({
                token: 'selectedTeam',
                deps: [],
                resolveFn: () => selectedTeam
            });

            transition.addResolvable({
                token: 'calendarIds',
                deps: [],
                resolveFn: () => filter(
                    map(cid, (id) => +id),
                    (id) => some(
                        selectedTeam.calendars,
                        (calendar) => calendar.id === id
                    )
                )
            });

            transition.addResolvable({
                token: 'teams',
                deps: [],
                resolveFn: () => filter(teams, (team) => team.calendars.length > 0)
            });

            transition.addResolvable({
                token: 'startOfWeek',
                deps: [],
                resolveFn: () => {
                    return preferences.startWeekOnSunday ? 0 : 1;
                }
            });

            time = moment(+time);
            transition.addResolvable({
                token: 'time',
                deps: [],
                resolveFn: () => {
                    return time.isValid()
                        ? time.valueOf()
                        : null;
                }
            });

            return true;
        }).catch(() => {
            return $state.target('authorized');
        });
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/index.js